import {
  request,
  success,
  failure,
  FINANCE_DASHBOARD_REQUEST,
} from "./utilities";
import {
  incomeExpenseData,
  fetchExpenseTypeWise,
  fetchProjectBudgetLeads,
  fetchMonthlyExpense,
  yearlyIncomeExpense,
} from "../api";

export function getIncomeExpenseGraphData() {
  return (dispatch) => {
    dispatch(
      request(FINANCE_DASHBOARD_REQUEST.GET_INCOME_EXPENSE_GRAPH_REQUEST)
    );
    incomeExpenseData().then(
      (response) => {
        if (response.data.status === 1) {
          dispatch(
            success(
              FINANCE_DASHBOARD_REQUEST.GET_INCOME_EXPENSE_GRAPH_SUCCESS,
              response.data.data
            )
          );
        } else {
          dispatch(
            failure(
              FINANCE_DASHBOARD_REQUEST.GET_INCOME_EXPENSE_GRAPH_FAILURE,
              response.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            FINANCE_DASHBOARD_REQUEST.GET_INCOME_EXPENSE_GRAPH_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function getExpenseTypeWiseAnalysis(data) {
  return (dispatch) => {
    dispatch(
      request(FINANCE_DASHBOARD_REQUEST.GET_EXPENSE_TYPE_WISE_ANALYSIS_REQUEST)
    );
    fetchExpenseTypeWise(data).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(
              FINANCE_DASHBOARD_REQUEST.GET_EXPENSE_TYPE_WISE_ANALYSIS_SUCCESS,
              res.data.data
            )
          );
        } else {
          dispatch(
            failure(
              FINANCE_DASHBOARD_REQUEST.GET_EXPENSE_TYPE_WISE_ANALYSIS_FAILURE,
              res.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            FINANCE_DASHBOARD_REQUEST.GET_EXPENSE_TYPE_WISE_ANALYSIS_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function getProjectBudgetLead() {
  return (dispatch) => {
    dispatch(
      request(FINANCE_DASHBOARD_REQUEST.GET_PROJECT_BUDGET_LEAD_REQUEST)
    );
    fetchProjectBudgetLeads().then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(
              FINANCE_DASHBOARD_REQUEST.GET_PROJECT_BUDGET_LEAD_SUCCESS,
              res.data.data
            )
          );
        } else {
          dispatch(
            failure(
              FINANCE_DASHBOARD_REQUEST.GET_PROJECT_BUDGET_LEAD_FAILURE,
              res.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            FINANCE_DASHBOARD_REQUEST.GET_PROJECT_BUDGET_LEAD_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function getMonthlyExpenses(monthIdx, token) {
  return (dispatch) => {
    dispatch(request(FINANCE_DASHBOARD_REQUEST.GET_MONTHLY_EXPENSES_REQUEST));
    fetchMonthlyExpense(monthIdx, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(
              FINANCE_DASHBOARD_REQUEST.GET_MONTHLY_EXPENSES_SUCCESS,
              res.data.data
            )
          );
        } else {
          dispatch(
            failure(
              FINANCE_DASHBOARD_REQUEST.GET_MONTHLY_EXPENSES_FAILURE,
              res.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            FINANCE_DASHBOARD_REQUEST.GET_MONTHLY_EXPENSES_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function getYearlyIncomeExpense(data, token) {
  return (dispatch) => {
    dispatch(
      request(FINANCE_DASHBOARD_REQUEST.GET_YEARLY_INCOME_EXPENSE_REQUEST)
    );
    yearlyIncomeExpense(data, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(
              FINANCE_DASHBOARD_REQUEST.GET_YEARLY_INCOME_EXPENSE_SUCCESS,
              res.data.data
            )
          );
        } else {
          dispatch(
            failure(
              FINANCE_DASHBOARD_REQUEST.GET_YEARLY_INCOME_EXPENSE_FAILURE,
              res.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            FINANCE_DASHBOARD_REQUEST.GET_YEARLY_INCOME_EXPENSE_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}
